import { RepInfoSteps } from "constants/enums";

export const getRepFormData = (state) => state.passenger.formData;
export const getRepLoading = (state) => state.passenger.loading;
export const getCompletedStepIndex = (state) =>
  state.passenger.completedStepIndex;
export const getCurrentStepKey = (state) => state.passenger.currentStepKey;
export const getSteps = (state) => state.passenger.steps;
export const getCurrentStepLocked = (state) =>
  state.passenger.steps.find((x) => x.key === state.passenger.currentStepKey)
    ?.locked;
export const getIsSubmitted = (state) => state.passenger.isSubmitted;
export const getIsConfirmed = (state) => state.passenger.isConfirmed;
export const hasAgreedToSubmission = (state) => {
  const formData = getRepFormData(state);
  return !!formData[RepInfoSteps.Submit]?.agree;
};
export const getIsSubmitting = (state) => state.passenger.submitting;
export const getIsSaving = (state) => state.passenger.saving;
export const getIsValid = (state) => state.passenger.isValid;
export const getSaveCount = (state) => state.passenger.saveCount;
export const getIsFormDirty = (state) => state.passenger.dirty;
